function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 174",
  transform: "rotate(30 162.003 -12.41)",
  stroke: "#3c00dc",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 72",
  cx: 8.99,
  cy: 8.99,
  r: 8.99,
  transform: "translate(98.733 85.036)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 276",
  d: "M107.724 130.411h17.285v-35.4c0-35.4-17.285-50.981-17.285-50.981S90.442 59.6 90.442 95.008v35.4h17.286z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 277",
  d: "M119.501 130.411v5.579H96.033v-5.579",
  strokeWidth: 0.98
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 26",
  strokeWidth: 0.98,
  d: "M90.565 118.775h25.393"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 279",
  d: "M90.438 110.466a54.828 54.828 0 00-23.856 34.517h4.737s10.091-11.342 19.119-14.57",
  strokeWidth: 0.98
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280",
  d: "M125.009 110.466a54.823 54.823 0 0123.856 34.517h-4.736s-10.09-11.343-19.12-14.572",
  strokeWidth: 0.98
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 27",
  strokeWidth: 0.98,
  d: "M123.029 75.225H105.4"
}));

function SvgRocketinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.43,
    height: 117.997,
    viewBox: "0 0 102.43 117.997"
  }, props), _ref);
}

export default SvgRocketinline;